<template>
  <div>
    <fdw-odds-comparison
      client="114"
      league="nfl"
      state="WORLD"
    ></fdw-odds-comparison>
  </div>
</template>

<script>
export default {
  name: "NflOdds",
};
</script>
